package com.milta.core.localization.translations.it

import com.milta.core.localization.AuthStrings

internal val Auth = AuthStrings(
    login = "Accedi",
    logout = "Esci",
    email = "Email",
    password = "Password",
    showPassword = "Mostra",
    hidePassword = "Nascondi",
    roleSelectionTitle = "Crea un account",
    roleSelectionSubtitle = "Scegli il tipo di account che corrisponde al tuo profilo",
    roleDriverTitle = "Sono un autista - corriere",
    roleDriverDescription = "Guido un veicolo di trasporto o consegna e voglio ottimizzare i miei giri",
    roleDriverTag1 = "Ottimizza i miei giri",
    roleDriverTag2 = "Offerte Milta sul mio percorso",
    roleEnterpriseTitle = "Sono un'azienda",
    roleEnterpriseDescription = "Ho un numero di IVA e gestisco una flotta di veicoli e un team di autisti",
    roleEnterpriseTag1 = "Gestione flotta",
    roleEnterpriseTag2 = "Monitoraggio team",
    continueButton = "Continua",
    registerFormTitle = "Completa la registrazione",
    registerFormSubtitle = "Conferma il tuo numero di telefono per attivare il tuo account.",
    registerFormSubtitleEnterprise = "Inserisci la tua organizzazione e un numero di telefono per attivare il tuo account.",
    googleAccountConnected = "Account Google connesso",
    appleAccountConnected = "Account Apple connesso",
    firstName = "Nome",
    lastName = "Cognome",
    phoneNumber = "Numero di telefono",
    phoneNumberHelper = "Inserisci il numero di telefono che preferisci.",
    phoneNumberOtpInfo = "Un codice di verifica verrà inviato via SMS per confermare questo numero.",
    registerButton = "Ricevi un codice di verifica",
    passwordHint = "Almeno 8 caratteri",
    registerSuccess = "Account creato con successo",
    errorEmailConflict = "Questo indirizzo email è già in uso",
    errorPhoneConflict = "Questo numero di telefono è già registrato",
    errorGeneric = "Connessione fallita. Controlla la rete e riprova.",
    errorFirstNameRequired = "Inserisci il tuo nome",
    errorFirstNameTooLong = "Il nome non può superare i 100 caratteri",
    errorLastNameRequired = "Inserisci il tuo cognome",
    errorLastNameTooLong = "Il cognome non può superare i 100 caratteri",
    errorPhoneTooLong = "Il numero di telefono non può superare i 20 caratteri",
    errorOAuthAccountExists = "Questo account è già collegato a un altro account Milta. Prova ad accedere.",
    errorOAuthTokenInvalid = "La tua sessione è scaduta. Accedi di nuovo.",
    loginTitle = "Accedi",
    loginTabPassword = "Password",
    loginTabPhone = "Telefono",
    loginButton = "Accedi",
    forgotPassword = "Password dimenticata?",
    sendCodeButton = "Invia codice",
    otpTitle = "Inserisci il codice",
    otpSubtitle = "Abbiamo inviato un codice a 6 cifre al",
    otpVerifyButton = "Verifica",
    otpResend = "Reinvia codice",
    otpResendPrefix = "Non hai ricevuto il codice?",
    otpWrongNumber = "Numero sbagliato?",
    otpModifyLink = "Modifica",
    forgotPasswordTitle = "Password dimenticata",
    forgotPasswordSubtitle = "Inserisci la tua email per ricevere un link di reset",
    forgotPasswordButton = "Invia link",
    forgotPasswordSuccess = "Controlla la tua casella di posta",
    resetPasswordTitle = "Nuova password",
    resetPasswordSubtitle = "Scegli una nuova password per il tuo account",
    resetPasswordNewLabel = "Nuova password",
    resetPasswordConfirmLabel = "Conferma password",
    resetPasswordButton = "Reimposta password",
    resetPasswordSuccess = "Password reimpostata. Ora puoi accedere.",
    errorPasswordTooShort = "La password deve contenere almeno 8 caratteri",
    errorPasswordTooLong = "La password non può superare i 128 caratteri",
    errorPasswordMismatch = "Le password non corrispondono",
    errorTokenInvalid = "Questo link di reset non è valido o è scaduto. Richiedine uno nuovo.",
    errorEmailInvalid = "Inserisci un indirizzo email valido",
    errorPhoneRequired = "Inserisci un numero di telefono",
    errorInvalidCredentials = "Email o password errati. Usa 'Password dimenticata?' se necessario.",
    errorInvalidOtp = "Codice errato. Controlla il tuo SMS o richiedine uno nuovo.",
    errorExpiredOtp = "Codice scaduto. Richiedine uno nuovo.",
    errorTooManyAttempts = "Troppi tentativi falliti. Riprova tra qualche minuto.",
    errorResendLimit = "Troppe richieste di reinvio. Riprova tra qualche minuto.",
    otpResendIn = "Reinvia tra %d s",
    otpAttemptsLeft = "Ti restano %d tentativi",
    loginGreeting = "Bentornato!",
    loginSubtitle = "Accedi al tuo account Milta",
    loginSmsOption = "Ricevere un codice SMS",
    noAccount = "Non hai ancora un account?",
    signUp = "Registrati",
    organizationName = "Nome dell'organizzazione",
    organizationNameRequired = "Inserire il nome dell'organizzazione",
    registerNextButton = "Avanti",
    passwordConfirm = "Conferma password",
    passwordRuleUpper = "Una lettera maiuscola",
    passwordRuleDigit = "Una cifra",
    passwordRuleSpecial = "Un carattere speciale",
    alreadyHaveAccount = "Hai già un account — Accedi",
)
